import "./Checkout_Mobile.css";
import Footer from "../components/shared/Footer";
import useCheckoutLogic from "../hooks/useCheckoutLogic";
import MobileTopBar from "../components/mobile/MobileTopBar";
import BillingFormFields from "./shared/BillingFormFields";
import OrderSummaryContent from "./shared/OrderSummaryContent";

const Checkout_Mobile = () => {
  const {
    cartItems,
    isLoading,
    checkoutError,
    formData,
    fieldErrors,
    handleInputChange,
    isFormValid,
    shippingCost,
    total,
    countries,
    handleSubmit,
    handlePayment,
    closeCheckoutError,
  } = useCheckoutLogic();

  return (
    <div>
      <MobileTopBar />
      <form className="checkout-form-mobile" onSubmit={handleSubmit}>
        <div className="checkout-left-side-mobile">
          <div className="ct-billing-sketch-mobile">
            <div className="billing-shipping-mobile">
              <BillingFormFields
                formData={formData}
                fieldErrors={fieldErrors}
                handleInputChange={handleInputChange}
                countries={countries}
              />
            </div>
          </div>

          <div className="checkout-overview-order-mobile">
            <OrderSummaryContent
              cartItems={cartItems}
              formData={formData}
              shippingCost={shippingCost}
              total={total}
              isFormValid={isFormValid}
              handlePayment={handlePayment}
              isLoading={isLoading}
              checkoutError={checkoutError}
              closeCheckoutError={closeCheckoutError}
              isMobile={true}
            />
          </div>
        </div>
      </form>
      <Footer />
    </div>
  );
};

export default Checkout_Mobile;
